import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from '../../axios';
import { PaperAirplaneIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';
import Indeterminado from '../../Layout/Loaders/Indeterminado';

const RecuperarPassword = () => {
    const [email, setEmail] = useState('');
    const [loader, setLoader] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    const handleSubmit = (e) => {
        e.preventDefault();
        setMessage({ type: '', text: '' });
        
        if (email === '') {
            setMessage({ type: 'error', text: 'El campo de correo no puede estar vacío.' });
            return;
        }

        setLoader(true);
        axios.post('/api/password_reset', { email })
            .then(res => {
                setLoader(false);
                setMessage({ type: 'success', text: res.data.message });
            })
            .catch(e => {
                const mensaje = e.response?.status === 404
                    ? e.response?.data?.message
                    : "Error desconocido";
                setMessage({ type: 'error', text: mensaje });
                setLoader(false);
            });
    };

    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-center bg-cover bg-no-repeat m-0 p-0 bg-[#6DB3F2]"
            style={{ backgroundImage: "url('/images/bg-principal.png')" }}>
            {loader && <Indeterminado />}
            {/* Contenedor transparente exterior */}
            <div className="rounded-lg flex items-center justify-center m-0 p-0 h-[76vh] w-[76%] max-[659px]:w-[95%] max-[659px]:h-auto max-[659px]:py-8 bg-white/10 shadow-[0_0_20px_-10px_rgba(255,255,255,1)]">
                {/* Contenedor transparente interior */}
                <div className="rounded-lg flex flex-col items-center m-0 p-0 h-[75%] w-[75%] max-[659px]:w-[95%] max-[659px]:h-auto bg-white/10 shadow-[0_0_20px_-10px_rgba(255,255,255,1)] pt-8">
                    {/* Logo */}
                    <div className="flex items-center justify-center">
                        <img 
                            className="h-[154px] max-[659px]:h-[100px] rounded-[40%] shadow-[0_0_20px_-10px_rgba(255,255,255,1)]" 
                            src="/images/logo2.png" 
                            alt="Dento Metric System" 
                        />
                    </div>
                    
                    {/* Formulario */}
                    <div className="rounded-lg shadow-[0_0_15px_0_rgba(0,51,255,1)] bg-white h-auto w-[40vw] max-[659px]:w-[90%] p-6 mt-8">
                        <div className="flex items-center justify-center">
                            <div className="w-full px-2">
                                <form className="w-full" id="recuperar-form" onSubmit={handleSubmit}>
                                    {/* Título con degradado */}
                                    <h5 className="font-semibold text-xl max-[659px]:text-lg flex items-center justify-center mb-6">
                                        <img src="/images/sesion.png" alt="" className="h-5 max-[659px]:h-4 pr-3" />
                                        <span className="bg-gradient-to-r from-[#0033ff] to-[#11cdef] bg-clip-text text-transparent">
                                            ¿No puedes iniciar sesión?
                                        </span>
                                    </h5>

                                    {/* Success/Error message */}
                                    {message.text && (
                                        <div className={`mb-4 p-3 rounded-lg text-sm text-center ${
                                            message.type === 'success' 
                                                ? 'bg-green-50 border border-green-200 text-green-700'
                                                : 'bg-red-50 border border-red-200 text-red-700'
                                        }`}>
                                            {message.text}
                                        </div>
                                    )}

                                    {/* Email */}
                                    <div className="mb-6">
                                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                                            Enviaremos un link de recuperación a
                                        </label>
                                        <input 
                                            id="email" 
                                            type="email" 
                                            placeholder="Ingresa tu correo"
                                            className="dento-input w-full px-3 py-2 border-b border-blue-600 focus:border-b-2 focus:outline-none bg-transparent box-border"
                                            onChange={(e) => setEmail(e.target.value)} 
                                            required
                                        />
                                    </div>

                                    {/* Submit button */}
                                    <div className="text-right">
                                        <button 
                                            className="bg-[#0033ff] text-white px-6 py-2 rounded-md uppercase font-bold text-sm border-2 border-[#0033ff] hover:bg-white hover:text-[#0033ff] hover:shadow-[0_0_15px_0_rgba(0,51,255,1)] transition-all duration-300 inline-flex items-center gap-2 max-[659px]:text-xs cursor-pointer"
                                            type="submit"
                                        >
                                            Enviar link de recuperación
                                            <PaperAirplaneIcon className="h-5 w-5" />
                                        </button>
                                    </div>
                                </form>

                                {/* Divider */}
                                <div className="flex items-center gap-2 my-5 w-full">
                                    <hr className="flex-1 border-gray-300" />
                                    <span className="text-gray-500">-</span>
                                    <hr className="flex-1 border-gray-300" />
                                </div>

                                {/* Back to login */}
                                <div className="text-center">
                                    <Link 
                                        className="text-blue-600 hover:text-blue-800 hover:underline inline-flex items-center gap-2" 
                                        to="/login"
                                    >
                                        <ArrowLeftIcon className="h-4 w-4" />
                                        Volver al Inicio de sesión
                                    </Link>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecuperarPassword;